<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Horas Insumidas en Capacitación</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Año" dense v-model="filtroperiodo">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-btn tile color="success" @click="cargarListados()">
                                <v-icon left> mdi-magnify </v-icon>
                                Buscar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="200" hide-default-footer>
                <template v-slot:item.tipo_curso="{ item }">
                    {{ tipoCursoTexto(item.tipo_curso) }}
                </template>
                <template slot="body.append">
                    <tr>
                        <th>
                            <h6><b>TOTAL</b></h6>
                        </th>
                        <th>
                            <h6><b>{{ total.toFixed(2) }}</b></h6>
                        </th>
                    </tr>
                </template>
            </v-data-table>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroperiodo: moment().format("YYYY"),
        listado: [],
        total: 0,
        flag: "",

        headers: [
            {
                text: "Tipo de Capacitación",
                align: "center",
                sortable: false,
                value: "tipo_curso",
            },
            { text: "Horas insumidas", value: "total_horas", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                // this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        tipoCursoTexto(tipo) {
            switch (tipo) {
                case 'S': return 'SGI';
                case 'G': return 'Gestión';
                case 'T': return 'Técnica';
                case 'C': return 'Comercial';
                default: return tipo;
            }
        },
        cargarListados() {
            this.vaciarModels();

            const periodo = this.filtroperiodo;
            this.periodoanterior = parseInt(this.filtroperiodo) - 1;
            let self = this;

            axios
                .get("/RRHH/HorasCapacitacion?", {
                    params: {
                        periodo: periodo,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    for (let i = 0; i < response.data.length; i++) {
                        self.total += parseFloat(response.data[i].total_horas);
                    }
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
            this.total = 0;
        },
    },
};
</script>